import styles from "./VehicleSelector.module.css";

const VehicleSelector = ({
    value,
    onChange,
    options = [],
    placeholder = "انتخاب خودرو",
}) => {

    return (

        <div className={styles.wrapper}>

            <select
                className={styles.select}
                value={value ?? ""}
                onChange={(event) =>
                    onChange(event.target.value)
                }
            >

                {!value && (

                    <option value="">
                        {placeholder}
                    </option>

                )}

                {options.map((vehicle) => (

                    <option
                        key={vehicle.id}
                        value={vehicle.id}
                    >

                        {vehicle.title}

                    </option>

                ))}

            </select>

        </div>

    );

};

export default VehicleSelector;
